// extracted by mini-css-extract-plugin
export default {"questionIcon":"ModalTitle_questionIcon__VRqbC","description":"ModalTitle_description__iw1rq"};